export const stopEventPropagation = (e) => e.stopPropagation();